import { render } from "./RuiCardBorder.vue?vue&type=template&id=470cc026&scoped=true"
import script from "./RuiCardBorder.vue?vue&type=script&lang=ts"
export * from "./RuiCardBorder.vue?vue&type=script&lang=ts"

import "./RuiCardBorder.vue?vue&type=style&index=0&id=470cc026&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-470cc026"

export default script